import {mapActions, mapGetters} from 'vuex'

export const assetMixin = {
  computed: {
    ...mapGetters({
      'assets': 'assets/all'
    })
  },
  methods: {
    ...mapActions({
      'getAssets': 'assets/getAssets',
      'getImageAssets': 'assets/getImageAssets',
      'getVideoAssets': 'assets/getVideoAssets',
      'uploadAssets': 'assets/uploadAssets',
      'uploadFootage': 'assets/uploadFootage',
      'deleteFootage': 'assets/deleteFootage',
      'deleteAsset': 'assets/deleteAsset'
    })
  }
}



// WEBPACK FOOTER //
// ./src/mixins/assetMixin.js